// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()

// firestore
export const db = getFirestore(app)


// auth

export const signInWithGoogle = () => {
  signInWithPopup(auth, googleProvider)
    .then((res) => {
      // console.log(res.user)
      localStorage.setItem('aa-auth', JSON.stringify(res.user))
      window.location.reload()
    }).catch((err) => {
      alert(err)
    })
}

export const signOutGoogle = () => {
  signOut(auth)
    .then((res) => {
      alert('Logged Out Successfully!')
      localStorage.removeItem('aa-auth')
      window.location.reload()
    }).catch((err) => {
      alert(err)
    })
}